// https://www.npmjs.com/package/mitt
import mitt from 'mitt';

// 类型
const emitter = mitt();

// 导出
export default emitter;
